import { useEffect, useRef, useState } from 'react'
import { string } from 'prop-types'
import Div from '@ui/layout/Div'
import Icon from '@ui/elements/Icon'

const MIN_SCALE = 1
const MAX_SCALE = 5
const SCALE_STEP = 0.5

const PhotoZoomViewer = ({ src, alt = '' }) => {
  const [scale, setScale] = useState(MIN_SCALE)
  const [offset, setOffset] = useState({ x: 0, y: 0 })
  const dragStart = useRef(null)

  const updateScale = newScale => {
    newScale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, newScale))
    setScale(newScale)
    if (MIN_SCALE === newScale) {
      setOffset({ x: 0, y: 0 })
    }
  }

  const handleWheel = e => updateScale(scale + (e.deltaY < 0 ? SCALE_STEP : -SCALE_STEP))

  const handlePointerDown = e => {
    if (MIN_SCALE === scale) return
    e.currentTarget.setPointerCapture(e.pointerId)
    dragStart.current = { x: e.clientX - offset.x, y: e.clientY - offset.y }
  }

  const handlePointerMove = e => {
    if (!dragStart.current) return
    setOffset({ x: e.clientX - dragStart.current.x, y: e.clientY - dragStart.current.y })
  }

  const handlePointerUp = () => {
    dragStart.current = null
  }

  useEffect(() => {
    updateScale(MIN_SCALE)
  }, [src])

  return (
    <Div cssClass='photo-zoom-viewer'>
      <Div
        cssClass={`photo-zoom-area ${scale > MIN_SCALE ? 'is-zoomed' : ''}`}
        otherProps={{
          onWheel: handleWheel,
          onDoubleClick: () => updateScale(scale > MIN_SCALE ? MIN_SCALE : MAX_SCALE / 2),
          onPointerDown: handlePointerDown,
          onPointerMove: handlePointerMove,
          onPointerUp: handlePointerUp,
          onPointerCancel: handlePointerUp
        }}
      >
        <img
          src={src}
          alt={alt}
          draggable={false}
          style={{ transform: `translate(${offset.x}px, ${offset.y}px) scale(${scale})` }}
        />
      </Div>
      <Div cssClass='photo-zoom-controls'>
        <Icon icon='icon-zoom_out' spanClass='is-medium' callback={() => updateScale(scale - SCALE_STEP)} />
        <span>{Math.round(scale * 100)}%</span>
        <Icon icon='icon-zoom_in' spanClass='is-medium' callback={() => updateScale(scale + SCALE_STEP)} />
      </Div>
    </Div>
  )
}

PhotoZoomViewer.propTypes = {
  src: string,
  alt: string
}

export default PhotoZoomViewer
